export default [
  { value: 'MEI', label: 'MEI - Micro Empreendedor Individual' },
  { value: 'LIMITED', label: 'Empresa Limitada' },
  { value: 'INDIVIDUAL', label: 'Pessoa Física' },
]
